import React, { useEffect, useState } from 'react'

function PopUp() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  // const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  useEffect(() => {
    const handleClickAnywhere = () => {
      if (deferredPrompt) {
        handleInstallClick();
      }
    };
    document.addEventListener("click", handleClickAnywhere);

    return () => {
      document.removeEventListener("click", handleClickAnywhere);
    };
  }, [deferredPrompt]);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      // console.log("data now");

      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
      });
    }
  };


  return (null);
};

export default PopUp;